<template>

</template>

<script>
import confetti from 'canvas-confetti';

export default {
  name: 'VueConfetti',
  data() {
    return {};
  },

  created() {
    let duration = 30 * 10;
    let end = Date.now() + duration;

    (function frame() {
      confetti({
        particleCount: 30,
        spread: 150,
        // startVelocity: 40,
        angle: 90,
        // decay: 0.9
      });

      // keep going until we are out of time
      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    }());
  }
};
</script>
